var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"truncate"},[(_vm.slotFilled)?_c('i',{staticClass:"far fa-check-circle text-green-600"}):_c('i',{staticClass:"fas fa-check-circle text-green-600"}),_vm._v(" "+_vm._s(_vm.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }